<template>
  <!-- 收藏统计 -->
  <div class="goodsAnalysis">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['数据分析', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData"
          >导出数据</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <!-- <el-date-picker
          v-model="searchForm.Time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          style="margin-right: 5px"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker> -->
        <label class="label">是否有货：</label>
        <el-select
          placeholder="是否有货"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.isStock"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="有货" value="Y"></el-option>
          <el-option label="无货" value="N"></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入关键字"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsId"
        align="center"
        show-overflow-tooltip
        label="商品编号"
      >
      </el-table-column>
      <el-table-column
        prop="erpCode"
        align="center"
        show-overflow-tooltip
        label="ERP编号"
      >
      </el-table-column>
      <el-table-column
        prop="goodsName"
        align="center"
        show-overflow-tooltip
        label="商品名称"
      >
      </el-table-column>
      <el-table-column
        prop="spec"
        align="center"
        show-overflow-tooltip
        label="规格"
      >
      </el-table-column>
      <el-table-column
        prop="factory"
        align="center"
        show-overflow-tooltip
        label="单位/产地"
      >
      </el-table-column>
      <el-table-column
        prop="stock"
        align="center"
        show-overflow-tooltip
        label="库存"
      >
      </el-table-column>
      <el-table-column
        prop="startDate"
        align="center"
        show-overflow-tooltip
        label="首次销售日期"
      >
      </el-table-column>
      <el-table-column
        prop="endDate"
        align="center"
        show-overflow-tooltip
        label="末次销售日期"
      >
      </el-table-column>
      <el-table-column
        prop="dateNum"
        align="center"
        show-overflow-tooltip
        label="停销天数"
      >
      </el-table-column>
      <el-table-column
        prop="price15"
        align="center"
        show-overflow-tooltip
        label="15天内销售额"
      >
      </el-table-column>
      <el-table-column
        prop="price30"
        align="center"
        show-overflow-tooltip
        label="30天内销售额"
      >
      </el-table-column>
      <el-table-column
        prop="price60"
        align="center"
        show-overflow-tooltip
        label="31~60天销售额"
      >
      </el-table-column>
      <el-table-column
        prop="OrderNum"
        align="center"
        show-overflow-tooltip
        label="商品下单数"
      >
      </el-table-column>
      <el-table-column
        prop="ClientNum"
        align="center"
        show-overflow-tooltip
        label="商品下单客户数"
      >
      </el-table-column>
      <el-table-column
        prop="TotalNum"
        align="center"
        show-overflow-tooltip
        label="总数量"
      >
      </el-table-column>
      <el-table-column
        prop="TotalAmount"
        align="center"
        show-overflow-tooltip
        label="总金额"
      >
      </el-table-column>
      <el-table-column
        prop="goodsAllNum"
        align="center"
        show-overflow-tooltip
        label="品规数"
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "goodsAnalysis",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**搜索表单 */
      searchForm: {
        isStock: "",
        type: "",
        name: "",
        Time: [], //时间范围
        startTime: "",
        endTime: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      if (this.searchForm.Time == null) {
        this.searchForm.startTime = "";
        this.searchForm.endTime = "";
      } else {
        this.searchForm.startTime = this.searchForm.Time[0];
        this.searchForm.endTime = this.searchForm.Time[1];
      }
      let data = {
        type: "GoodsOperationData",
        strWhere: this.searchForm.name,
        Inventory: this.searchForm.isStock,
        ABCType: this.searchForm.type,
        // startTime: this.searchForm.startTime,
        // endTime: this.searchForm.endTime,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = 0;
          if (res.flag == 0) {
            this.allPage = res.recordCount;
            this.tableData = res.data.map((item) => ({
              goodsId: item.article_id, // 商品编号
              erpCode: item.erp_spid, // ERP编号
              goodsName: item.sub_title, // 商品名称
              spec: item.drug_spec, // 规格
              factory: item.drug_factory, // 单位/产地
              stock: item.stock_quantity, // 库存
              startDate: item.FirstSaleDate, // 首次销售日期
              endDate: item.LastSaleDate, // 末次销售日期
              dateNum: item.txts, // 停销天数
              price15: item.fifteenxse, // 15天内销售额
              price30: item.thirtyxse, // 	30天内销售额
              price60: item.sixtyxse, // 31~60天销售额
              goodsAllNum: item.pgs, // 品规数
              OrderNum: item.OrderNum,
              TotalAmount: item.TotalAmount,
              TotalNum: item.TotalNum,
              ClientNum: item.ClientNum,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    exportData() {
      let data = {
        type: "GoodsOperationData",
        userId: window.localStorage.getItem("userId"),
        entId: window.localStorage.getItem("entId"),
        strWhere: this.searchForm.name,
        Inventory: this.searchForm.isStock,
        ABCType: this.searchForm.type,
        PageIndex: 1,
        PageSize: 9999999,
      };
      let proc = "Proc_Admin_Statistical"; // 存储过程名
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=商品分析";
    },
  },
};
</script>

<style scoped>
.goodsAnalysis {
  width: 100%;
  height: 100%;
}
</style>
